import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PolicyList from '../../components/Policies/PolicyList';
import PolicyToolbar, {
    PolicySortKey,
    PolicyTypeFilter,
} from '../../components/Policies/PolicyToolbar';
import UserRole from '../../../shared/AuthRoles';
import { useNavigate } from 'react-router-dom';

import { CustomButton } from '../../../layout/styledcomponents/CustomButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ExperienceType } from '../../enums/experience';

export default function PoliciesPage() {
    const loggedInUser = UserRole();
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const theme = useTheme();

    useEffect(() => {
        if (loggedInUser.role !== 'owner_admin') {
            navigate(`/permissionDenied`, { state: { name: 'policiesPage' } });
        }
    }, [loggedInUser.role, navigate]);

    // ---- toolbar state ----
    const [query, setQuery] = useState('');
    const [typeFilter, setTypeFilter] = useState<PolicyTypeFilter>('All');
    const [expFilter, setExpFilter] = useState<ExperienceType[]>([]);
    const [sortKey, setSortKey] = useState<PolicySortKey>('nameAsc');

    const onClickGoBack = () => navigate(`/adminCentre/host`);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile || isIpad ? '100%' : '95%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Box sx={{ px: { xs: 2, md: 0 }, width: '100%' }}>
                {/* Title */}
                <Grid
                    sx={{
                        width: '100%',
                        height: isMobile || isIpad ? 'auto' : '5%',
                        justifyContent: 'left',
                        display: 'flex',
                        mb: 1.5,
                    }}
                >
                    <Typography
                        variant='h1'
                        sx={{
                            textAlign: 'left',
                            textTransform: 'uppercase',
                        }}
                    >
                        Policies
                    </Typography>
                </Grid>

                {/* Toolbar */}
                <Box sx={{ mt: 0.5 }}>
                    <PolicyToolbar
                        query={query}
                        onQueryChange={setQuery}
                        typeFilter={typeFilter}
                        onTypeFilterChange={setTypeFilter}
                        expFilter={expFilter}
                        onExpFilterChange={setExpFilter}
                        sortKey={sortKey}
                        onSortKeyChange={setSortKey}
                    />
                </Box>

                {/* List */}
                <Box sx={{ mt: 1.5, pb: 2 }}>
                    <PolicyList
                        query={query}
                        typeFilter={typeFilter}
                        expFilter={expFilter}
                        sortKey={sortKey}
                    />
                </Box>

                {/* Back button (hidden on mobile) */}
                <Grid
                    sx={{
                        height: '5%',
                        display: isMobile || isIpad ? 'none' : 'flex',
                    }}
                >
                    <CustomButton
                        onClick={onClickGoBack}
                        color='primary'
                        sx={{
                            marginLeft: '-8px',
                            '&:hover': {
                                cursor: 'pointer',
                                color: theme.palette.textAccent.main,
                                backgroundColor: 'transparent',
                                background: 'none',
                            },
                        }}
                    >
                        <ArrowBackIcon />
                        <Typography
                            sx={{ fontSize: '12px', paddingLeft: '5px' }}
                        >
                            Back
                        </Typography>
                    </CustomButton>
                </Grid>
            </Box>
        </Grid>
    );
}
